/**
 * "All agents are busy" UI shown when chat escalation times out without
 * an agent accepting. Mirrors the call-support widget's NO_AGENTS screen
 * (apps/web/src/components/client-portal/ClientCallWidget.tsx) — a
 * friendly visual instead of a plain text bubble.
 */
export function AgentsBusy({ onRetry, onClose }: {
  onRetry: () => void
  onClose: () => void
}) {
  return (
    <div className="kc3-widget kc3-widget--agents-busy">
      <div className="kc3-widget-header">
        <div className="kc3-widget-header__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>
        <div className="kc3-widget-header__content">
          <span className="kc3-widget-header__title">Live Agent</span>
          <span className="kc3-widget-header__subtitle">
            <span className="kc3-widget-header__offline" />
            All agents busy
          </span>
        </div>
      </div>

      <div className="kc3-agents-busy-body">
        <div className="kc3-agents-busy-icon" aria-hidden="true">
          <div className="kc3-agents-busy-icon__circle" />
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="56"
            height="56"
            className="kc3-agents-busy-icon__headset"
          >
            <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
            <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
          </svg>
          <span className="kc3-agents-busy-icon__badge" aria-hidden="true">…</span>
        </div>

        <p className="kc3-agents-busy-title">All agents are busy right now 😥</p>
        <p className="kc3-agents-busy-desc">
          Our team is helping other customers. You can try again in a few minutes.
        </p>

        <div className="kc3-agents-busy-actions">
          <button
            type="button"
            className="kc3-agents-busy-btn kc3-agents-busy-btn--retry"
            onClick={onRetry}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
              <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
              <path d="M3 3v5h5" />
            </svg>
            <span>Try Again</span>
          </button>

          <button
            type="button"
            className="kc3-agents-busy-btn kc3-agents-busy-btn--close"
            onClick={onClose}
          >
            <span>Maybe Later</span>
          </button>
        </div>

        <div className="kc3-agents-busy-wait">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <div>
            <p className="kc3-agents-busy-wait__title">Average wait time: 2-4 minutes</p>
            <p className="kc3-agents-busy-wait__sub">We appreciate your patience! 💜</p>
          </div>
        </div>
      </div>

      <div className="kc3-widget-footer">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="12" height="12">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        <span>Your data is secure and private</span>
      </div>
    </div>
  )
}
